import React from "react";
import styled from "styles/styled_components";

import Icon, { ICON_COLOR, ICON_TYPE } from "components/shared/icon";

const StyledHoverMask = styled.div`
  background-color: ${(props) => props.theme.colors.brandWhite};
  padding: ${(props) => props.theme.spacing.small};
  position: absolute;
  text-align: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  & > svg {
    margin: 0 ${(props) => props.theme.spacing.small};
  }
`;

interface IBlockHoverMask {
  onEdit?: () => void;
  onDelete: () => void;
}

export default function BlockHoverMask({ onEdit, onDelete }: IBlockHoverMask) {
  return (
    <StyledHoverMask>
      {typeof onEdit === "function" && (
        <Icon
          color={ICON_COLOR.BLUE}
          type={ICON_TYPE.EDIT}
          onClick={onEdit}
          lightenOnHover
        />
      )}
      <Icon
        color={ICON_COLOR.BLUE}
        type={ICON_TYPE.TRASH}
        onClick={onDelete}
        lightenOnHover
      />
    </StyledHoverMask>
  );
}
